module.exports = ".ip1 {\n    margin: .4rem;\n    padding: 0.4rem;\n    padding-left: 1.2rem;\n    width: 98%;\n    border-radius: 0.3rem;\n    border: solid #FBAA39 0.1rem;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/select-brand/select-brand.component.css
// module id = ./src/app/select-brand/select-brand.component.css
// module chunks = main